import React, { FC, useMemo } from 'react';
import { AppModal } from './reusable-components/app-modal/AppModal';
import { GenericMessages } from '../intl/GenericMessages';
import './OneButtonModal.scss';
import { useIntl } from 'react-intl';

/**
 * Holds the title and message for the modal.
 *
 * The first element is the title and the second is the message.
 */
export type OneButtonModalContent = [string, string];

export interface OneButtonModalProps {
  isOpen: boolean;
  onClose: () => void;
  content: OneButtonModalContent;
  buttonLabel?: string;
}

/**
 * A modal with a single button, e.g. Ok.
 *
 * @param isOpen
 * @param onClose
 * @param content
 * @param buttonLabel
 * @constructor
 */
export const OneButtonModal: FC<OneButtonModalProps> = ({ isOpen, onClose, content, buttonLabel }) => {
  const { formatMessage } = useIntl();
  const okButton = useMemo(() => {
    return {
      label: buttonLabel ?? formatMessage(GenericMessages.okButtonLabel),
      onClick: onClose,
    };
  }, [buttonLabel, formatMessage, onClose]);

  return (
    <AppModal className="OneButtonModal" isOpen={isOpen} title={content[0]} primaryButton={okButton} onClose={onClose}>
      {content[1]}
    </AppModal>
  );
};
